<template>
  <div
    v-if="loaded"
    id="termos-de-uso"
  >
    <funcionalidade-header
      v-if="!esconderHeader"
      :voltar="buttonVoltar"
      :custom-voltar="true"
      :titulo="titulo"
      @click="$emit('voltar')"
    />
    <div
      id="scrollbar-none"
      class="termos-content"
    >
      <div class="header-termos">
        <h1 class="titulo-termos">{{ termoDeUso.titulo }}</h1>
        <small class="versao-termo">Versão {{ termoDeUso.versao }} - atualizado em {{ dataTermo }}</small>
        <small
          v-if="dataAceite"
          class="versao-termo"
        >
          Termo aceito em {{ dataAceito }}
        </small>
      </div>
      <div class="border-dashed"/>
      <div
        class="termos-text"
        v-html="termoDeUso.conteudo_termo_uso"
      />
    </div>
    <el-footer
      v-if="buttonsFooter"
      class="footer-termos"
    >
      <div class="button-options">
        <el-button
          class="button-text"
          :style="`background: ${corBotaoSecundario}; color: ${corTextoBotaoSecundario}`"
          @click="aceitarTermo(false)"
        >
          NÃO ACEITO
        </el-button>
        <el-button
          :style="`background: ${botaoPrincipal}; color: ${textoBotaoPrincipal}`"
          class="button-primary"
          @click="aceitarTermo(true)"
        >
          DECLARO QUE LI E ACEITO
        </el-button>
      </div>
    </el-footer>
  </div>
</template>
<script>
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'TermosDeUsoComponent',
  data () {
    return {
      termoDeUso: '',
      dataAceite: '',
      loaded: false,
      aceito: false,
      internalIdTermo: this.idTermo
    }
  },
  props: {
    idTermo: {
      type: [Number, String]
    },
    buttonVoltar: {
      type: Boolean,
      default: true
    },
    buttonsFooter: {
      type: Boolean,
      default: false
    },
    verificarDataAceite: {
      type: Boolean,
      default: true
    },
    esconderHeader: {
      type: Boolean,
      default: false
    },
    titulo: {
      type: String,
      default: 'Termos de uso'
    }
  },
  watch: {
    idTermo: {
      handler (newVal) {
        this.internalIdTermo = newVal
        this.init()
      }
    }
  },
  components: {
    FuncionalidadeHeader
  },
  computed: {
    ...mapState('SetupApp', ['apiTermoDeUso']),
    ...mapGetters('SetupApp', ['estilo']),
    dataTermo () {
      return moment(this.termoDeUso.data_publicacao).format('DD/MM/YYYY')
    },
    dataAceito () {
      return moment(this.dataAceite).format('DD/MM/YYYY')
    },
    botaoPrincipal () {
      return this.estilo.botaoPrincipal.corBotaoPrincipal
    },
    textoBotaoPrincipal () {
      return this.estilo.botaoPrincipal.corTextoBotaoPrincipal
    },
    corBotaoSecundario () {
      return this.estilo.botaoSecundario.corBotaoSecundario
    },
    corTextoBotaoSecundario () {
      return this.estilo.botaoSecundario.corTextoBotaoSecundario
    },
    termoDef () {
      return this.$route.query.idTermo
    }
  },
  methods: {
    async init () {
      if (!this.internalIdTermo) this.internalIdTermo = this.termoDef
      if (this.verificarDataAceite) {
        await this.verificarAceite()
      }
      await this.getTermosDeUso()

      if (!this.termoDeUso.sempre_exibir && this.aceito) {
        this.$emit('aceito', { aceito: true })
      } else {
        this.loaded = true
      }
    },
    async getTermosDeUso () {
      const result = await this.apiTermoDeUso.getUltimoTermoDeUsoValido({
        loading: true,
        payload: {
          'id_termo_uso_plat': this.internalIdTermo
        },
        handlerErrorIgnore: true
      })
      this.termoDeUso = result.data
      this.loaded = true
    },
    async verificarAceite () {
      const result = await this.apiTermoDeUso.termosUsoVerificarAceite({
        loading: true,
        payload: {
          'id_termo_uso_plat': this.internalIdTermo
        },
        handlerErrorIgnore: true
      })
      this.dataAceite = result.data.data_aceite
      this.aceito = result.data.aceito

      this.$emit('dataAceite', this.dataAceite)
    },
    async aceitarTermo (aceito) {
      const response = await this.apiTermoDeUso.termosUsoConfirmarAceite({
        loading: true,
        payload: {
          'id_termo_uso_plat': this.internalIdTermo,
          'aceito': aceito,
          'versao': this.termoDeUso.versao,
          'id_termo_uso': this.termoDeUso.id_termo_uso
        },
        handlerErrorIgnore: true
      })

      if (aceito && response.data.aceito) {
        this.$emit('aceito', response.data)
      } else {
        this.$emit('cancelar')
      }
    }
  },
  mounted () {
    this.init()
  }
}
</script>
<style scoped>
.termos-content {
  padding-left: 20px;
  max-width: 609px;
}

.header-termos {
  margin-bottom: 30px;
}

.border-dashed {
  border-bottom: dashed 1px #EEEEEE;
  margin-bottom: 30px;
}

.titulo-termos {
  margin-top: 20px;
  font-family: 'Noto', sans-serif;
  font-size: 36px;
}

.versao-termo {
  display: block;
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
  margin-top: 5px;
  color: #555555;
}

.footer-termos {
  box-shadow: 0 2px 8px #0001011A;
  height: 64px;
  display: flex;
  justify-content: center;
}

#scrollbar-none::-webkit-scrollbar {
  width: 0;
}

.button-options {
  padding-top: 15px;
  display: flex;
  flex-flow: row nowrap;
}

.button-text {
  border: none;
  width: 295px;
  height: 34px;
}

.button-primary {
  width: 295px;
  height: 34px;
}
</style>
